var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, normalizeProps as _normalizeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = { class: "title_group" };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = {
    key: 0,
    class: "buttons d-flex gap-2 align-items-center"
};
var _hoisted_5 = ["href"];
var _hoisted_6 = ["disabled"];
var _hoisted_7 = {
    key: 0,
    class: "files upload_list_group d-flex align-items-center flex-wrap"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
    key: 0,
    class: "upload_list d-flex align-items-center"
};
var _hoisted_10 = { class: "d-flex align-items-center" };
var _hoisted_11 = { class: "d-flex align-items-center" };
var _hoisted_12 = { class: "filename" };
var _hoisted_13 = ["onClick"];
var _hoisted_14 = ["href"];
var _hoisted_15 = {
    key: 0,
    class: "upload_list d-flex align-items-center"
};
var _hoisted_16 = { class: "d-flex align-items-center" };
var _hoisted_17 = { class: "d-flex align-items-center" };
var _hoisted_18 = {
    key: 0,
    src: "/images/icons/icon_pdf.png",
    alt: ""
};
var _hoisted_19 = {
    key: 1,
    src: "/images/icons/icon_image.png",
    alt: ""
};
var _hoisted_20 = { class: "filename" };
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
    key: 1,
    class: "lastupdate"
};
var _hoisted_23 = ["name", "onUpdate:modelValue"];
var _hoisted_24 = ["name", "onUpdate:modelValue"];
var _hoisted_25 = ["name", "onUpdate:modelValue"];
var _hoisted_26 = ["name", "onUpdate:modelValue"];
import Swal from "sweetalert2";
import { reactive, watch, ref, computed } from 'vue';
import { useDropzone } from 'vue3-dropzone';
import moment from "moment";
import ApiService from "@/ts/core/services/ApiService";
import { useI18n } from 'vue-i18n';
import { UserPartnershipApplicationStatus } from "@/ts/enums/UserPartnershipApplicationStatus";
import { startSpinner } from '@/ts/modules/startSpinner';
var maxFileCount = 10;
export default /*@__PURE__*/ _defineComponent({
    __name: 'FileUploadCard',
    props: {
        fieldName: { default: '' },
        locales: {},
        title: { default: '타이틀' },
        manual: { default: '' },
        download: { default: '' },
        required: { type: Boolean, default: false },
        url: { default: '' },
        status: { default: UserPartnershipApplicationStatus.PENDING },
        files: { default: function () { return []; } }
    },
    emits: ['changed'],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var _b = useI18n(), locale = _b.locale, t = _b.t;
        var url = props.url;
        var state = reactive({
            files: ref([]),
        });
        var API_HOST = process.env.MIX_API_HOST;
        var didSyncedPhotos = false; // 최초 1번만...
        watch(function () { return props.files; }, function () {
            console.log(props.fieldName, props.files);
            if (props.files.length > 0 && !didSyncedPhotos) {
                props.files.forEach(function (photo) {
                    state.files.push(photo);
                });
                didSyncedPhotos = true;
            }
        });
        var _c = useDropzone({
            onDrop: onDrop,
        }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive, rest = __rest(_c, ["getRootProps", "getInputProps", "isDragActive"]);
        function onDrop(acceptFiles, rejectReasons) {
            var _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
            console.log(acceptFiles, rejectReasons);
            if (acceptFiles.length + state.files.filter(function (file) { return file.status != 'delete'; }).length > maxFileCount) {
                return Swal.fire({
                    text: '에러문구..',
                    icon: "error",
                    confirmButtonText: props.locales.common_confirm,
                    heightAuto: false,
                });
            }
            var formData = new FormData(); // pass data as a form
            formData.append('category', props.fieldName);
            for (var x = 0; x < acceptFiles.length; x++) {
                // append files as array to the form, feel free to change the array name
                formData.append("files[]", acceptFiles[x]);
            }
            // post the formData to your backend where storage is processed. In the backend, you will need to loop through the array and save each file through the loop.
            ApiService.axiosInstance.post(API_HOST + url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(function (_a) {
                var data = _a.data;
                data.data.forEach(function (element) {
                    element.status = "create";
                    state.files.push(element);
                });
            })
                .catch(function (err) {
                console.error(err, err.response.data);
                var errMessage = err.response.data ? err.response.data.message : err.response.statusText;
                Swal.fire({
                    text: errMessage,
                    icon: "error",
                    confirmButtonText: props.locales.common_confirm,
                    heightAuto: false,
                });
            })
                .finally(function () {
                if (spinnerContainer) {
                    spinnerContainer.style.display = 'none';
                }
                spinner.stop();
            });
        }
        /**
         *
         * @param index
         * @description 삭제 API 호출
         */
        var handleClickDeleteFile = function (index) { return __awaiter(_this, void 0, void 0, function () {
            var file;
            return __generator(this, function (_a) {
                file = state.files[index];
                return [2 /*return*/, ApiService.delete(API_HOST + "/partnership/user-file/".concat(file.public_key))
                        .then(function () {
                        state.files.splice(index, 1);
                    })];
            });
        }); };
        function getValidCount() {
            return state.files.filter(function (file) { return file.status != 'delete'; }).length;
        }
        /**
         * @description created_at 기준 가장 최근 파일을 리턴
         */
        var latestFile = computed(function () {
            if (state.files.length === 0)
                return null;
            return state.files.reduce(function (latest, current) {
                return moment(current.created_at).isAfter(moment(latest.created_at)) ? current : latest;
            }, state.files[0]);
        });
        var downloadFile = function (downloadUrl) {
            var _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
            ApiService.query(downloadUrl, {
                responseType: 'blob'
            })
                .then(function (response) {
                console.log(response, response.headers["content-disposition"]);
                var contentDisposition = response.headers['content-disposition']; // 파일 이름
                console.log("contentDisposition", contentDisposition);
                var fileName = 'unknown';
                if (contentDisposition) {
                    var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
                    }
                }
                var headers = response.headers;
                var blob = new Blob([response.data], { type: headers['content-type'] });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                link.remove();
            })
                .catch(function (_a) {
                var response = _a.response;
                Swal.fire({
                    icon: 'error',
                    text: response.data.message || 'error',
                    confirmButtonText: props.locales.value.common_confirm || 'ok',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-primary",
                    }
                });
            })
                .finally(function () {
                if (spinnerContainer) {
                    spinnerContainer.style.display = 'none';
                }
                spinner.stop();
            });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "fileupload_card",
                id: "file_field_".concat(_ctx.fieldName.split('_')[1])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["card_content d-flex justify-content-between", props.manual == '' && props.download == '' ? 'align-items-center' : ''])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(props.title), 1),
                            (_ctx.required)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                                : _createCommentVNode("", true)
                        ]),
                        (props.manual !== '' || props.download !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (props.manual !== '')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: props.manual,
                                        target: "_blank",
                                        class: "manual d-flex gap-1 align-items-center"
                                    }, [
                                        _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                            width: "18",
                                            height: "19",
                                            viewBox: "0 0 18 19",
                                            fill: "none"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M10.5 2.20215V5.30005C10.5 5.72009 10.5 5.93011 10.5817 6.09055C10.6537 6.23167 10.7684 6.3464 10.9095 6.41831C11.0699 6.50005 11.28 6.50005 11.7 6.50005H14.7979M10.5 13.25H6M12 10.25H6M15 7.99117V13.4C15 14.6601 15 15.2902 14.7548 15.7715C14.539 16.1948 14.1948 16.539 13.7715 16.7548C13.2902 17 12.6601 17 11.4 17H6.6C5.33988 17 4.70982 17 4.22852 16.7548C3.80516 16.539 3.46095 16.1948 3.24524 15.7715C3 15.2902 3 14.6601 3 13.4V5.6C3 4.33988 3 3.70982 3.24524 3.22852C3.46095 2.80516 3.80516 2.46095 4.22852 2.24524C4.70982 2 5.33988 2 6.6 2H9.00883C9.55916 2 9.83432 2 10.0933 2.06217C10.3229 2.11729 10.5423 2.2082 10.7436 2.33156C10.9707 2.4707 11.1653 2.66527 11.5544 3.05442L13.9456 5.44558C14.3347 5.83473 14.5293 6.0293 14.6684 6.25636C14.7918 6.45767 14.8827 6.67715 14.9378 6.90673C15 7.16568 15 7.44084 15 7.99117Z",
                                                stroke: "#6C6C6C",
                                                "stroke-width": "1.5",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            })
                                        ], -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.locales.common_manual), 1)
                                    ], 8, _hoisted_5))
                                    : _createCommentVNode("", true),
                                (props.download !== '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        onClick: _cache[0] || (_cache[0] = function ($event) { return (downloadFile(props.download)); }),
                                        class: "download d-flex gap-1 align-items-center"
                                    }, [
                                        _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                            width: "18",
                                            height: "19",
                                            viewBox: "0 0 18 19",
                                            fill: "none"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M15 9.875V5.6C15 4.33988 15 3.70982 14.7548 3.22852C14.539 2.80516 14.1948 2.46095 13.7715 2.24524C13.2902 2 12.6601 2 11.4 2H6.6C5.33988 2 4.70982 2 4.22852 2.24524C3.80516 2.46095 3.46095 2.80516 3.24524 3.22852C3 3.70982 3 4.33988 3 5.6V13.4C3 14.6601 3 15.2902 3.24524 15.7715C3.46095 16.1948 3.80516 16.539 4.22852 16.7548C4.70982 17 5.33985 17 6.59989 17H9.375M11.25 14.75L13.5 17M13.5 17L15.75 14.75M13.5 17V12.5",
                                                stroke: "#6C6C6C",
                                                "stroke-width": "1.5",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            })
                                        ], -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.locales.common_downloadform), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (getValidCount() < maxFileCount)
                        ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, _unref(getRootProps)())), [
                            _createElementVNode("input", _mergeProps(_unref(getInputProps)(), {
                                name: "resume_attachments",
                                type: "file",
                                accept: "image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            }), null, 16),
                            _createElementVNode("button", {
                                type: "button",
                                disabled: props.status !== _unref(UserPartnershipApplicationStatus).PENDING,
                                class: "fileupload_btn blue_btn"
                            }, _toDisplayString(_ctx.locales.common_fileupload), 9, _hoisted_6)
                        ], 16))
                        : _createCommentVNode("", true)
                ], 2),
                (getValidCount() > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.files, function (file, index) {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (file.type === 'ms_word')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: function ($event) { return (downloadFile(file.download_url)); },
                                        class: "cursor-pointer"
                                    }, [
                                        (file.status != 'delete')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _cache[3] || (_cache[3] = _createElementVNode("img", {
                                                            src: "/images/icons/icon_document.png",
                                                            alt: ""
                                                        }, null, -1)),
                                                        _createElementVNode("span", _hoisted_12, _toDisplayString(file.file_name), 1)
                                                    ]),
                                                    (props.status == _unref(UserPartnershipApplicationStatus).PENDING)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            class: "x_btn",
                                                            onClick: _withModifiers(function ($event) { return (handleClickDeleteFile(index)); }, ["stop", "prevent"])
                                                        }, _cache[4] || (_cache[4] = [
                                                            _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                                                        ]), 8, _hoisted_13))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 8, _hoisted_8))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: file.url,
                                        target: "_blank"
                                    }, [
                                        (file.status != 'delete')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createElementVNode("div", _hoisted_17, [
                                                        (file.type == 'pdf')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                                            : (file.type == 'image')
                                                                ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                                                : _createCommentVNode("", true),
                                                        _createElementVNode("span", _hoisted_20, _toDisplayString(file.file_name), 1)
                                                    ]),
                                                    (props.status == _unref(UserPartnershipApplicationStatus).PENDING)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            class: "x_btn",
                                                            onClick: _withModifiers(function ($event) { return (handleClickDeleteFile(index)); }, ["stop", "prevent"])
                                                        }, _cache[5] || (_cache[5] = [
                                                            _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                                                        ]), 8, _hoisted_21))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 8, _hoisted_14))
                            ], 64));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                (latestFile.value != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.locales.common_lastupdate) + " : " + _toDisplayString(_unref(moment)(latestFile.value.created_at).format('YYYY.MM.DD HH:mm')), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.files, function (file, seq) {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            name: "resume_attachments[".concat(seq, "][path]"),
                            "onUpdate:modelValue": function ($event) { return ((file.path) = $event); }
                        }, null, 8, _hoisted_23), [
                            [_vModelText, file.path]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            name: "resume_attachments[".concat(seq, "][file_name]"),
                            "onUpdate:modelValue": function ($event) { return ((file.file_name) = $event); }
                        }, null, 8, _hoisted_24), [
                            [_vModelText, file.file_name]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            name: "resume_attachments[".concat(seq, "][status]"),
                            "onUpdate:modelValue": function ($event) { return ((file.status) = $event); }
                        }, null, 8, _hoisted_25), [
                            [_vModelText, file.status]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            name: "resume_attachments[".concat(seq, "][id]"),
                            "onUpdate:modelValue": function ($event) { return ((file.id) = $event); }
                        }, null, 8, _hoisted_26), [
                            [_vModelText, file.id]
                        ])
                    ], 64));
                }), 256))
            ], 8, _hoisted_1));
        };
    }
});
